import {
  Button,
  CashIcon,
  ConfirmationModal,
  CurrencyInput,
  CustomToast,
  MinusCircleIcon,
  Select,
} from '@/components';
import {getLedgerReasonOptions} from '@/constants/formatters';
import type {AdminAfriexPerson} from '@/types';

import ConfirmationLabel from './ConfirmationLabel';
import useFundUserWallet from './useFundUserWallet';

const initialResponse = {
  message: '',
  status: '',
};

const CreditsUserWallet = ({user}: {user: AdminAfriexPerson}) => {
  const {
    amount,
    currency,
    loading,
    showModal,
    response,
    action,
    handleAmountChange,
    handleCurrencyChange,
    handleLedgerButtonClick,
    isValidTransaction,
    handleLedger,
    setShowModal,
    setResponse,
    handleSelectReason,
    fundWalletReason,
  } = useFundUserWallet(user, initialResponse);
  return (
    <div className="flex flex-col md:px-3 pt-5 gap-3 md:w-4/12">
      <h3 className="text-sm font-semibold text-gray-600 dark:text-gray-200">
        Credit / Debit User
      </h3>

      <div className="flex flex-col gap-6">
        <CurrencyInput
          onAmountChange={handleAmountChange}
          onCurrencyChange={handleCurrencyChange}
          selectedCurrency={currency}
          amount={amount}
          name="amount"
        />

        <Select
          onChange={handleSelectReason}
          value={fundWalletReason}
          name="fundWalletReason"
          options={getLedgerReasonOptions()}
          placeholder="Select a Reason"
          label="Attach Reason"
          bodyClassName="dark:bg-dark-inputBg"
        />

        {/* Credit - Debit Button */}
        <div className="flex justify-between space-x-4">
          <Button
            variant="outline"
            className="border-indigo-300"
            name="credit"
            disabled={isValidTransaction()}
            onClick={() => handleLedgerButtonClick('credit')}
            colorScheme="green"
            leftIcon={<CashIcon className="h-5 w-5" />}
          >
            Credit
          </Button>
          <Button
            variant="outline"
            name="debit"
            className="border-indigo-300"
            disabled={isValidTransaction()}
            onClick={() => handleLedgerButtonClick('debit')}
            colorScheme="red"
            leftIcon={<MinusCircleIcon className="h-5 w-5" />}
          >
            Debit
          </Button>
        </div>
      </div>

      {response.status && (
        <CustomToast
          variant={response.status}
          message={response.message}
          onClose={() => setResponse(initialResponse)}
        />
      )}

      <ConfirmationModal
        isOpen={showModal}
        label={
          <ConfirmationLabel
            action={action}
            amount={amount}
            currency={currency}
            user={user}
            fundWalletReason={fundWalletReason}
          />
        }
        cancelAction={() => setShowModal(false)}
        cancelActionLabel="No"
        confirmAction={handleLedger}
        confirmActionLabel="Yes"
        loadingLabel={loading ? '' : ''}
        loading={loading}
        title={`Confirm ${action}`}
      />
    </div>
  );
};

export default CreditsUserWallet;
